import { SocketEvent } from '../models/socketEvent';

export function decodeChatGatewayEventData(event: SocketEvent, s: any): any {
  switch (event) {
    case SocketEvent.NewMsg:
      if (typeof s !== 'string') {
        return null;
      }
      return JSON.parse(s)?.data;
    default:
      return null;
  }
}
